import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { CompanyPoService } from '../../../services/CompanyPoService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { GetCompanyPoListPagingAndFilterRequest, initialGetCompanyPoListPagingAndFilterRequest } from '../../../models/request/companyPo/GetCompanyPoListPagingAndFilterRequest';
import { GetCompanyPoListPagingAndFilterResponse, GetCompanyPoListPagingAndFilterResponseData, GetCompanyPoListPagingAndFilterResponseItem, initialGetCompanyPoListPagingAndFilterResponseData } from '../../../models/response/companyPo/GetCompanyPoListPagingAndFilterResponse';
import CompanyPoListFilters from './Components/CompanyPoListFilters';
import { ExportCompanyPoListResponse } from '../../../models/response/companyPo/ExportCompanyPoListResponse';
import { DeleteCompanyPoResponse } from '../../../models/response/companyPo/DeleteCompanyPoResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { ServiceService } from '../../../services/ServiceService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const CompanyPoList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > PO Eşleştirme"
    const pageVersion = "2";
    const [data, setData] = useState<GetCompanyPoListPagingAndFilterResponseData>(initialGetCompanyPoListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetCompanyPoListPagingAndFilterRequest>(initialGetCompanyPoListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Proje', name: 'projectName', order: 0, isVisible: true },
            { title: 'Gönderici - Alıcı Kodu', name: 'senderCode', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Bölüm', name: 'divisionName', order: 0, isVisible: true },
            { title: 'PO', name: 'poName', order: 0, isVisible: true },
            { title: 'PO Numarası', name: 'poNo', order: 0, isVisible: true },
            { title: 'Başlangıç Tarihi', name: 'startDateStr', order: 0, isVisible: true },
            { title: 'Bitiş Tarihi', name: 'endDateStr', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Gönderici - Alıcı Kayıtlı Değil', name: 'isSenderReceiverUnregistered', order: 0, isVisible: true },
            { title: 'Yurtiçi Alıcı', name: 'matchReceiverCustomerName', order: 0, isVisible: true },
            { title: 'Varış Birimi', name: 'matchArrivalUnitName', order: 0, isVisible: true },
            { title: 'Yurtiçi Gönderici', name: 'matchSenderCustomerName', order: 0, isVisible: true },
            { title: 'Teslim Eden', name: 'matchDeliverer', order: 0, isVisible: true },
            { title: 'Teslim Alan', name: 'matchDeliveryReceiver', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    // Üst bardaki zilden gelen süzgeç (#512): liste açıkken de her gelişte (location.key) uygulanır; süzgeçsiz gelişte yalnız ilk açılışta veri çekilir.
    const location = useLocation();
    const gelenFiltreler: ColumnFilterModel[] | undefined = (location.state as any)?.columnFilters;
    const ilkAcilis = useRef(true);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    useEffect(() => {
        if (gelenFiltreler && gelenFiltreler.length > 0)
            getData({ ...filter, columnFilters: gelenFiltreler, currentPage: 1, skip: 0 });
        else if (ilkAcilis.current)
            getData();

        ilkAcilis.current = false;
    }, [location.key])

    const deleteCompanyPo = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.companyPoId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteCompanyPoResponse = await CompanyPoService.deleteCompanyPo(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateCompanyPo = async (_id: string | undefined = undefined) => {
        navigate('/companypo/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].companyPoId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetCompanyPoListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetCompanyPoListPagingAndFilterResponse = await CompanyPoService.getCompanyPoListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyPoId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportCompanyPoListResponse = await CompanyPoService.exportCompanyPoList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.companyPoId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi
    // iki satır halinde gösterildiği için listede yok.
    const sortableColumns = [
        'senderCode', 'customerName', 'divisionName', 'poName', 'poNo',
        'startDateStr', 'endDateStr', 'isCustomActive',
        'isSenderReceiverUnregistered', 'matchReceiverCustomerName', 'matchArrivalUnitName', 'matchSenderCustomerName', 'matchDeliverer', 'matchDeliveryReceiver'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (CompanyPoManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        projectName: { type: 'select', loadOptions: () => loadConstants('PROJECT') },
        senderCode: { type: 'text' },
        customerName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        divisionName: { type: 'select', loadOptions: () => loadConstants('DIVISION') },
        poName: { type: 'select', loadOptions: () => loadList(ServiceService.getServiceList(true), 'serviceId', x => x.name) },
        poNo: { type: 'text' },
        startDateStr: { type: 'date' },
        endDateStr: { type: 'date' },
        isCustomActive: YES_NO_FILTER,
        isSenderReceiverUnregistered: YES_NO_FILTER,
        matchReceiverCustomerName: { type: 'text' },
        matchArrivalUnitName: { type: 'text' },
        matchSenderCustomerName: { type: 'text' },
        matchDeliverer: { type: 'text' },
        matchDeliveryReceiver: { type: 'text' },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetCompanyPoListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "isSenderReceiverUnregistered") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}><StatusBadge text={item.isSenderReceiverUnregistered ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (['openingBalance'].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}>{Helpers.correctPrice(item2[column], 2)}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.companyPoId)} onDoubleClick={!item.companyId ? undefined : () => updateCompanyPo(item.companyPoId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <CompanyPoListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteCompanyPo}
                    updateFunction={updateCompanyPo}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={[...columns, { title: 'Bitiş uyarısı', name: 'bitisUyarisi', order: 0, isVisible: false }]}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.companyPoId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default CompanyPoList;